/**
 * 品牌主
 */

import { HTTP_ALB } from '../axios'

//  品牌主列表
export const getbrandlist = params => {
  return HTTP_ALB.get('/foundation/brand/list', params)
}

// 添加品牌主
export const addbrand = params => {
  return HTTP_ALB.post('/foundation/brand/add', params)
}
// 编辑品牌主
export const editbrand = params => {
  return HTTP_ALB.post('/foundation/brand/edit', params)
}
// 删除品牌主
export const deletebrand = params => {
  return HTTP_ALB.get('/foundation/brand/del', params)
}
